// extracted by mini-css-extract-plugin
export var productFeatures = "ProductCommonFeatures-module--productFeatures--mkpeY";
export var inner = "ProductCommonFeatures-module--inner--j9iCO";
export var showMoreContainer = "ProductCommonFeatures-module--showMoreContainer--JDI9d";